import React from 'react';
import { 
  Avatar, 
  Drawer, 
  IconButton,
  ListItem, 
  Typography, 
  useTheme
} from '@mui/material';
import { DrawerHeader, UserProfilePictureButton } from './styled';
import MobileDrawer from './MobileDrawer';
import useCurrentUserInfo from '../../hooks/useCurrentUserInfo';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

function MobileDrawerHousing({
  container,
  handleDrawerToggle,
  open,
  setOpen,
  drawerWidth
}) {

  const theme = useTheme();
  const userInfo = useCurrentUserInfo();
  const navigate 	= useNavigate();
  const { 
		isAuthenticated, 
		logout,
		loginWithRedirect,
	} = useAuth0();
  
  return (
    <Drawer
      container={container}
      variant="temporary"
      anchor='right'
      open={open}
      onClose={handleDrawerToggle}
      ModalProps={{
        keepMounted: true,
      }}
      sx={{
        display: { xs: 'block', sm: 'block', md: 'block', lg: 'none' },
        '& .MuiDrawer-paper': { 
          boxSizing: 'border-box', 
          width: drawerWidth, 
          backgroundColor: `${theme.palette.whites.main}` ,
          zIndex: '1500'
        },
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.5)', // Adjust opacity as needed
          backdropFilter: 'blur(2px)', // Optional: adds blur effect
        }
      }}
    >
      <DrawerHeader>
        {
          isAuthenticated && (
            <ListItem
              sx={{
                display: 'flex', 
                justifyContent: 'flex-start',
                flexDirection: 'column',
                alignItems: 'flex-start',
                flex: '2'
              }}
            >
              <UserProfilePictureButton
                onClick={() => {
                  navigate('/profile/info');
                  setOpen(false)
                }}
              >
                <Avatar 
                  alt={userInfo?.name?.split('')[0]} 
                  src={userInfo?.picture ?? 'https://res.cloudinary.com/djrbfvpit/image/upload/v1737317715/CloudSous%20Assets/saaschowlogo_idvkoc.png'} 
                  sx={{ 
                    width: 75, 
                    height: 75,
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    border: `1px solid ${theme.palette.grays.main}`
                  }}
                />
              </UserProfilePictureButton>
              <Typography 
                variant='primary'
                sx={{
                  color: `${theme.palette.grays.dk}`,
                  fontSize: '1.5rem',
                  fontWeight: '700',
                  marginTop: '1rem'
                }}
              >
                {userInfo?.name?.split(' ')[0] ?? 'Username'}
              </Typography>
              <Typography sx={{color: `${theme.palette.grays.mdDk}`}}>{userInfo?.email?.split(' ')[0] ?? 'Email: test@gmail.com'}</Typography>
            </ListItem>
          )
        }
        <IconButton 
          onClick={handleDrawerToggle}
          sx={{ 
            alignItems: 'flex-start', 
            position: 'absolute', 
            top: 5, 
            right: 5
          }}
        >
          <CloseOutlinedIcon 
            sx={{
              color: `${theme.palette.grays.main}`, 
              fontSize: '3rem',
              fontWeight: 300
            }} 
          />
        </IconButton>
      </DrawerHeader>
      <MobileDrawer
        open={open} 
        setOpen={setOpen} 
        logout={logout}
        isAuthenticated={isAuthenticated}
        isAdmin={userInfo?.isAdmin}
        loginWithRedirect={loginWithRedirect}
      />
    </Drawer>
  );
};

export default MobileDrawerHousing;